import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id A13368F4-66F6-4014-968E-7A7B2D99F038
 * name home-alert
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const HomeAlertIcon = createSvgIcon(<><path d="M12 3L2 12H5V20H19V12H22L12 3M13 18H11V16H13V18M13 14H11V8H13V14Z" /></>, 'HomeAlertIcon');
export default HomeAlertIcon